module.exports = require("bunyan");


//////////////////
// WEBPACK FOOTER
// external "bunyan"
// module id = 238
// module chunks = 0